
import { CanonicalBookMap } from '../canonicalBookMap';

export default {
  /* Introduction to Sociology 1e */ 'afe4332a-c97f-4fc4-be27-4e4d384a32d8': [
    /* Introduction to Sociology 3e */ ['746f171e-0d6a-4ef2-b69d-367880872f4a', {
      /* Preface */
      '29931d89-4928-4595-9055-5c79d84a0541': '6454d583-84a8-4ce1-9af2-36be28532b98',
      /* Introduction to Socioloty */
      'ffdef1d6-b02f-4ca0-8bd8-89ee41813aea': 'bdf8b962-cd9d-4752-a983-cd3d57b50f02',
      /* What is Sociology? */
      '6adb2f84-9885-4207-bf83-563a511d6acd': 'c8d9ab4b-dd9c-4dad-aa9f-00bae82cd0af',
      /* The History of Sociology */
      '203a8406-41ee-4048-88c9-ba31e7fc3d14': '5f36c280-1b4c-4abb-9407-61358242bee0',
      /* Theoretical Perspectives */
      '3a42f055-0287-4654-9f10-59e34491be4e': '746efd2e-8fb4-4368-98b4-45f6fd33eb27',
      /* Why Study Sociology? */
      '76749910-fbd4-4dac-88b3-9747127d74a5': 'e13dda45-c995-47e5-8146-0ac7e1015ce6',
      /* Introduction to Sociological Research */
      '244817fb-3186-4b6c-8396-8e1114a42759': '5f0b4a03-f79c-442a-9fae-0a8a1359f4df',
      /* Approaches to Sociological Research */
      'db372960-daf8-4b0a-bc1b-1eabad735cd1': '0f87b4b5-bdb9-478d-94e1-f6967392b249',
      /* Research Methods */
      '40c2d5ee-9f4b-47d1-8e06-d29abcd58517': '51969efe-44b2-4302-97b5-a50ed8bd0eaf',
      /* Ethical Concerns */
      '371536f2-bb85-411a-adc8-57f27df13d95': '90ffbc39-5865-42ad-bcd9-bfb740dbdfd7',
      /* Introduction to Culture */
      '15153144-060d-4393-8418-f6b3c9f1656e': 'd54ed6a4-1098-4b2c-b206-b7850002fd26',
      /* What Is Culture? */
      '6aa42901-7eb8-4575-80b5-282a1e9f5aa1': 'dde4d8cb-ce8f-4c68-bad2-786d7c0f5f29',
      /* Elements of Culture */
      'dd0ef13c-a33c-46c5-9ace-92480d7e19f9': '946e6080-b7be-495d-9679-667c0e985a18',
      /* Pop Culture, Subculture, and Cultural Change */
      'bc80e651-5899-4872-8794-a1d18a37f9a4': '5750bc50-77e4-42ed-a7a0-dcc31a562dcb',
      /* Theoretical Perspectives on Culture */
      '14fba504-dd54-46fb-ad08-9d6b86954ee7': 'ca2347f6-ca5a-46cf-bd8b-75768bd084a3',
      /* Introduction to Society and Social Interaction */
      'e9e10f3d-f915-4adf-b0c3-b81080e8bf40': 'ef238876-14ce-464f-ac5a-e30d656d77b7',
      /* Types of Societies */
      'cb87c883-2f5c-4d73-ab29-4d2354e2e48e': '526f33fb-2ed8-4d15-b2e5-2b83a2b97849',
      /* Theoretical Perspectives on Society */
      'c5b9353a-8e1f-484b-94d4-0d3b886e1661': 'c1bc1aa5-03ef-4909-90b3-f47d33bc0c85',
      /* Social Constructions of Reality */
      '00b50039-5567-417c-b71b-0df7ef800ebf': '040ac094-d7eb-4761-840f-04f22aa30797',
      /* Introduction to Socialization */
      '89c733d6-b1f4-423f-af6e-a888a9d36ddf': '432870f9-ca8c-475d-b171-11af7c328514',
      /* Theories of Self Development */
      'f116f1e5-ea5f-4646-b66b-d2f450aeb2fb': 'c55c99ae-0516-4279-abd1-755d85f42bab',
      /* Why Socialization Matters */
      'c8fd366d-1d6f-4056-bed2-a0d699d5259e': 'bac65f73-c682-4565-9160-fda8409a9e0f',
      /* Agents of Socialization */
      '9c45f9e1-4e14-4c7c-9cee-a1910499d87d': '4a762cc1-da3a-408d-8fcb-a5f57c6af751',
      /* Socialization Across the Life Course */
      '3ea35244-bbc9-4b47-b676-c18887683fbe': '7a006b94-2b4a-4f60-ac2e-5f1cf8500a47',
      /* Introduction to Groups and Organizations */
      '2d911146-c842-48a0-957b-90bb6c1c6935': '45a4685e-ef8f-4bfb-a584-4d023fa60bd9',
      /* Types of Groups */
      'd96347a9-1c7d-40f4-99de-08c525eb4ead': '2e236b4a-85d4-4640-a7df-f91ce95d7f3a',
      /* Group Size and Structure */
      'a4bd4798-1607-4535-bbf1-b9d594285ef7': '5af5f060-563c-46d6-9239-2dcc5eb17f46',
      /* Formal Organizations */
      'fa14346e-029d-4ec1-8aa6-b26e2f8b838a': 'db3d2810-0166-495e-8254-1df166163826',
      /* Introduction to Deviance, Crime, and Social Control */
      '02cde4ad-d95d-4c45-88fc-d71031e0c8f5': 'e22a4d88-dd1f-410f-a15d-5d1a16caa3f4',
      /* Deviance and Control */
      'b4bbf816-e73c-451d-8d9e-54c6ba0eb91b': '73acf5b5-9551-4ec3-8208-0938b2acc762',
      /* Theoretical Perspectives on Deviance */
      '1718d294-1bad-4863-89b1-bee5f3cac168': '334bb070-bffe-4cea-8386-2ebc455e5e6c',
      /* Crime and the Law */
      'e68d22ae-e0d9-444a-98b8-0728738abc92': '5520305c-c934-4d73-8779-229edab703ab',
      /* Introduction to Media and Technology */
      'de9e0804-1682-4250-bec9-d215891bf2fb': '62b4811d-0c36-4175-b4b9-b87e0121aa67',
      /* Technology Today */
      'f9f6ee01-0e02-408b-a452-14f9a79db57a': 'fcabfd7d-c9bf-4365-b3bc-37548cf60c27',
      /* Media and Technology in Society */
      '5c4a1828-c1a1-428c-86bb-92ff088b7461': '8c1fe4e0-906f-4831-a5f8-f637302b9998',
      /* Global Implications */
      '9ce0032f-61c8-4c5a-8b31-255d0e0fb138': 'd3311627-9427-42b7-ba60-7fc46ebc0cb1',
      /* Theoretical Perspectives on Media and Technology */
      '439e20b7-944f-4f5b-aa13-127da91b7886': '9771fb31-def5-4866-9a53-aa4e4eefead0',
      /* Introduction to Social Stratification in the United States */
      '3f79d649-f80d-4b6b-944c-14b36f87e14a': '88050bef-46be-4c54-8104-43daf366c374',
      /* What Is Social Stratification? */
      'c7c4cd8f-b2ee-43a5-a0c1-04b684707039': '8915773e-2bab-4a4e-bf54-bb94d35b26e8',
      /* Social Stratification and Mobility in the United States */
      'f1981870-d1b7-4718-9994-17a90cdfc3c2': '2bd53207-47cf-4968-8b04-dc1903f0225d',
      /* Global Stratification and Inequality */
      '343d61db-5251-4101-a943-23b8a2a9db4c': 'cb507d56-798b-4941-946a-fd825a0f5cd5',
      /* Theoretical Perspectives on Social Stratification */
      '65d28eb1-2115-4291-9e00-67b76e61e121': '7b677f99-aa60-4f6e-9bbc-69d428d32beb',
      /* Introduction to Global Inequality */
      'c83d9da0-9494-4bf4-80d0-7cc69fe63524': '5793e6d2-bc37-40a1-a6cc-de69a7687996',
      /* Global Stratification and Classification */
      '8d6e23fd-7fe2-461c-ae7a-90816869de71': 'f73ea9c9-c051-4d97-bea6-d235213f3a4e',
      /* Global Wealth and Poverty */
      '37f39155-e061-4a88-a58f-3e1163efe86d': 'a88e70f0-2a90-4e98-a978-d895560224c5',
      /* Theoretical Perspectives on Global Stratification */
      '8d9a6cf5-03d5-401a-bb48-5e71db3059bf': '64172b6a-8685-486b-a784-f1c96fcde21e',
      /* Introduction to Race and Ethnicity */
      '2693c798-fcf6-4e41-b850-74eace3849af': '7e6d02f2-9fe9-4696-927b-87b141005478',
      /* Racial, Ethnic, and Minority Groups */
      '65bd3065-1509-46ca-8890-2619bb6e6b24': 'ef3b2aab-ce5b-4b35-9ec7-7f588cf76737',
      /* Stereotypes, Prejudice, and Discrimination */
      '4d58da55-22b9-4262-9e72-dd7e8447ac68': '0edbeb4e-db80-4e63-afeb-e3b7448fe175',
      /* Theories of Race and Ethnicity */
      'dbfed5d8-697f-4800-9afb-9c17086f3931': 'e207a1bd-229d-435d-b2be-feb218954337',
      /* Intergroup Relationships */
      '0160f6fa-1201-4de9-862e-80897fc2f7d4': '05938a47-b4e3-4e5d-91f4-7d702ecbf185',
      /* Race and Ethnicity in the United States */
      'b296d0c0-689f-4d62-aa48-7cb96994c617': '6ae57670-6018-4994-a651-9a7755739413',
      /* Introduction to Gender, Sex, and Sexuality */
      'cd5f2536-178a-498c-b9c5-bf71a8a6429c': 'eca82f51-6e74-4d44-8897-784473cbaea3',
      /* The Difference Between Sex and Gender */
      '8144da41-917e-41ac-9b56-117e73186d46': '2cb1bb9b-62a0-461d-af73-647db2608cef',
      /* Gender */
      '6d134c0b-d788-4f48-95ea-e27b42f95a12': '9c2a4870-25a6-4be7-958b-f4cfe2edc441',
      /* Sex and Sexuality */
      'be12f4e8-35f3-4523-8f34-049c2c278f98': 'daa2005c-e793-403a-8138-8966743527b6',
      /* Introduction to Aging and the Elderly */
      'e56a1279-4b57-435e-a35f-527eb141e560': 'aa9e578c-a8de-4296-afa0-c205701738ef',
      /* Who Are the Elderly? Aging in Society */
      'f63d6bb6-ee5a-4415-a41f-071161d02480': '8907afb3-2050-406f-b99b-91656b44a872',
      /* The Process of Aging */
      '47b25374-10bd-48fd-bd2a-66b75aac06d2': '4a2cd675-c659-40bc-80a3-50ed002e844f',
      /* Challenges Facing the Elderly */
      '86896a6b-0a1b-4033-9577-6b7fa065382e': 'd77aa9eb-7f03-41cb-ac74-b1058c46fcb8',
      /* Theoretical Perspectives on Aging */
      '40d0eca0-56ac-41e8-81df-fb71105c2f5c': '2bbe750f-a065-4ab9-a092-dad76f09fc23',
      /* Introduction to Marriage and Family */
      'c3828547-7106-4623-873b-1a1bfc1364b2': 'b69dea58-83eb-46fc-85db-b7a0fe7f60e6',
      /* What Is Marriage? What Is a Family? */
      '82d463a2-13f2-46a1-ad09-530449ea1f30': '8680e355-7ca9-4d25-81c3-2cf35d6a54a7',
      /* Variations in Family Life */
      '231e3727-a935-4b59-b7dd-ca5179640505': '6b1bd506-8d81-4f46-bd02-4de90ad14be7',
      /* Challenges Families Face */
      'ddff5d08-078b-4ae6-aa93-a326dec3bf9d': '5b7d753b-e94a-49ad-8ee8-a82a2ae23eb0',
      /* Introduction to Religion */
      '90b34d62-0c9f-4bc5-8c5a-9f4218e98784': '25a8930a-a75a-4104-af3e-3b3656168979',
      /* The Sociological Approach to Religion */
      'b4444ae8-4b3e-4bd7-9eb4-7cd3660fabfd': 'f0212a7a-dcd7-4def-8e73-b75666b3d47a',
      /* World Religions */
      '7a7d3c2a-8526-4495-9543-9642ecbea548': '0d9cc835-5129-432b-99e8-6fe01c3492e6',
      /* Religion in the United States */
      'f77d035c-851b-4cd8-9458-bce7ef51b57c': '195b3cdc-5a0a-476e-9fd0-c5592777b541',
      /* Introduction to Education */
      '8c9ea9e6-d1d7-46d3-b538-ee1651189b9c': '0fa1e181-b3f5-4130-84c3-c56bed6087ba',
      /* Education around the World */
      'be807490-4121-420c-a442-4c2454ff0e8e': '2dc215d3-3592-4ad3-8791-69203a46b56f',
      /* Theoretical Perspectives on Education */
      'b59dc143-6aa1-42b4-9fe2-a29588c87ab3': 'b51cb16c-b4e3-4276-bc01-c1e55f3f7a80',
      /* Issues in Education */
      'af81ba85-5d48-48d5-beab-d3bdf91745d1': 'c33eb672-e588-49db-8904-7bd3f59141f3',
      /* Introduction to Government and Politics */
      '50a625a8-f884-4440-b007-78473a2d0f82': '70dc2bd6-2797-4873-9ff5-d99883edee8c',
      /* Power and Authority */
      '32d0a2fb-01f3-4e66-862c-f5e2763e72e9': '38f28809-b520-472f-8641-8f41b1aa7f39',
      /* Forms of Government */
      'c1529050-5576-4942-ba3c-b0201ec6945c': '8b0aaf0a-92d9-4d3b-8de7-b0fd43e9b0cd',
      /* Politics in the United States */
      'af9d7b98-0385-40bc-b2f5-600e4d42ea85': '103fb4d3-3c1c-40c8-bb67-fba843c4b50a',
      /* Theoretical Perspectives on Government and Power */
      '78cc23f7-c829-481e-8c6e-93509aae60bc': '885f8ec6-75f0-4444-a0ec-6bf5d421dfb6',
      /* Introduction to Work and the Economy */
      '5de5f6ad-4b72-4efa-92ec-b6441986ac3f': '2dce905a-8b18-4744-9059-68bf253fcdb1',
      /* Economic Systems */
      '4508a0c2-78bc-4b96-bb24-df590eb78337': '9736b5e6-5c55-4427-bbea-583631ec35d5',
      /* Globalization and the Economy */
      '30ef6b86-78b4-40ad-91a9-d8288296f4b9': 'bd95b55e-bd6e-42d5-9b24-d7245a4b2f0c',
      /* Work in the United States */
      '6403c01e-5244-481e-9b20-ca9b826a4394': '50990608-0ac5-48eb-aa99-a9895f3c684e',
      /* Introduction to Health and Medicine */
      'c7905d30-14f0-4b04-861c-3b75661bc524': '924e725d-f89a-4489-b5b0-b54fbbba9bc0',
      /* The Social Construction of Health */
      '1081951a-f4e7-40fd-8276-c78bd845d780': 'be196e13-bfd0-4c6f-ba08-dc3e0f243330',
      /* Global Health */
      '23e6d978-4262-415f-9ca4-3703827040f1': '6bd7a019-4c5f-4d67-bd2b-e95487d77b72',
      /* Health in the United States */
      'ef9f6ec6-7fdb-419f-9dfa-974364481a31': '0e24f38e-51de-48b7-98c7-e2cb84012915',
      /* Comparative Health and Medicine */
      '668dec5f-b5e2-4525-a031-86dc943ccc70': '82e9a288-e88b-44e5-b72d-65c467ac1700',
      /* Theoretical Perspectives on Health and Medicine */
      '1114b9d6-c6d6-49ae-beb6-8f77c4334efe': '82e9a288-e88b-44e5-b72d-65c467ac1700',
      /* Introduction to Population, Urbanization, and the Environment */
      '487480d4-94c5-47c4-a0c7-ccf32fa64a3c': '2578a895-c99f-4149-aab4-a8aa6c03f4b5',
      /* Demography and Population */
      '9bca072f-a390-46c4-976d-16ac6e0e1026': 'aaec018d-a1e6-4e6d-9d85-36f8274a9085',
      /* Urbanization */
      '395eff14-07a6-4364-ac1d-f87917501e83': '8ca3d600-1a6f-4535-94e4-1c13cb77d4c9',
      /* The Environment and Society */
      'f18a2de7-33c5-4ace-85f7-f6a37e0efd60': '7aed3dd9-7c4d-4a25-b903-3529583215e6',
      /* Introduction to Social Movements and Social Change */
      'a92a2476-30c8-4b64-81c9-634da2490dab': 'e475e719-67e9-4a51-9c2b-313d009991eb',
      /* Collective Behavior */
      '7f6d4334-2d56-4995-88ea-be47c71c5733': '6e69fbe2-9c5d-4c03-85db-565c56621331',
      /* Social Movements */
      '385b5c8d-3fcd-4283-99fa-0312b514c05c': '1272acf1-44da-4f2c-88e7-4eff807738e6',
      /* Social Change */
      'b9fed02b-edda-433d-adfa-fce8cc55091d': '4937c948-e669-42a4-98cc-fe18f2370de1',
    }],
  ],
  /* Introduction to Sociology 2e */ '02040312-72c8-441e-a685-20e9333f3e1d': [
    /* Introduction to Sociology 3e */['746f171e-0d6a-4ef2-b69d-367880872f4a', {
      /* Preface */
      '325e4afd-80b6-44dd-87b6-35aff4f40eac': '6454d583-84a8-4ce1-9af2-36be28532b98',
      /* 1.0 Introduction to Sociology */
      '4eb21133-cf0a-4ea7-81f5-b1e47698ec30': 'bdf8b962-cd9d-4752-a983-cd3d57b50f02',
      /* 1.1 What Is Sociology? */
      '5d97ba77-626b-4670-a1bb-c65fdd07bb0c': 'c8d9ab4b-dd9c-4dad-aa9f-00bae82cd0af',
      /* 1.2 The History of Sociology */
      '82966abb-ebb0-48ab-8576-a52a0e126bd9': '5f36c280-1b4c-4abb-9407-61358242bee0',
      /* 1.3 Theoretical Perspectives */
      '40c45f23-6a75-414a-987a-cccd50bd04b8': '746efd2e-8fb4-4368-98b4-45f6fd33eb27',
      /* 1.4 Why Study Sociology? */
      '2478dd75-fc23-48c8-9dfc-57a409d04c6b': 'e13dda45-c995-47e5-8146-0ac7e1015ce6',
      /* Key Terms */
      '13e975b8-eccc-55a8-b401-a3b43600dd24': '11c98620-c53b-535b-bbdc-ddd1ef36d101',
      /* Section Summary */
      '2fd5c0d2-f29a-5919-b6f3-c098f794a9d1': '50d4b682-6109-555f-8543-6ccb73ce4bbe',
      /* Section Quiz */
      'caee6ed8-d0d7-57d2-9696-6a9c1c3a79e2': '4dcd7bf8-20a4-5a64-aa2d-4d47c82b1725',
      /* Short Answer */
      '2a7f9a21-f0d1-5513-9956-57d65efb10c7': '7e09b639-bfe0-51c0-8a47-9f9ea42ca060',
      /* Further Research */
      'c42480ad-12a1-5d9a-bb93-127b0efec627': '4cd6c284-034c-5f0b-af14-305142888927',
      /* References */
      '8348c301-f6bc-52e1-b610-2b6721532d87': '28ae92a3-3c29-5c18-b41e-ce670aef8697',
      /* 2.0 Introduction to Sociological Research */
      'de329f8c-7690-4ea5-a3a4-d0ce6605d0ea': '5f0b4a03-f79c-442a-9fae-0a8a1359f4df',
      /* 2.1 Approaches to Sociological Research */
      'baee4db6-1e28-43f9-a0b7-a4f3c7263598': '0f87b4b5-bdb9-478d-94e1-f6967392b249',
      /* 2.2 Research Methods */
      'e72e915a-719d-4496-ac15-5197a2c11258': '51969efe-44b2-4302-97b5-a50ed8bd0eaf',
      /* 2.3 Ethical Concerns */
      '6d922c72-61cf-4f13-9b00-4f0c640cbf17': '90ffbc39-5865-42ad-bcd9-bfb740dbdfd7',
      /* Key Terms */
      '0b68696a-c5d6-555a-b3aa-c0cfaee872cc': '505d3ae0-33d4-5d8c-ace2-521136621662',
      /* Section Summary */
      'bae1ab4a-0967-5237-8ae3-d0a929f73337': 'ef6a8d86-4ac1-5ce9-a4fc-4de11341e8ec',
      /* Section Quiz */
      'eabe5ac5-3b18-531c-828f-cc6e28366464': '140c6672-1546-584f-890e-dec83a3ab650',
      /* Short Answer */
      '68020c4d-2398-543c-9924-c8dd64ff48ed': '84b0abf4-98a9-5734-877d-6cad4d0edacb',
      /* Further Research */
      '7d3e66c5-eaeb-5e95-a0f7-ad3a613e587a': '6cb418f8-7c36-5035-a194-b6ae2f3264b8',
      /* References */
      'c8a34847-9909-535e-a6da-cf48bea2a411': '2d3ccb65-6e39-576d-84c7-480c0a346025',
      /* 3.0 Introduction to Culture */
      '8a8ed60b-fb85-463f-a002-b48af257f894': 'd54ed6a4-1098-4b2c-b206-b7850002fd26',
      /* 3.1 What Is Culture? */
      'f87398b0-553a-4538-959d-15b28d0a80ef': 'dde4d8cb-ce8f-4c68-bad2-786d7c0f5f29',
      /* 3.2 Elements of Culture */
      'f298104a-d0dd-432f-83ec-3881813a7eaa': '946e6080-b7be-495d-9679-667c0e985a18',
      /* 3.3 Pop Culture, Subculture, and Cultural Change */
      '4ee317f2-cc23-4075-b377-51ee4d11bb61': '5750bc50-77e4-42ed-a7a0-dcc31a562dcb',
      /* 3.4 Theoretical Perspectives on Culture */
      'f2055c29-6b50-4a77-89d8-f88745ce0f18': 'ca2347f6-ca5a-46cf-bd8b-75768bd084a3',
      /* Key Terms */
      'e18718ba-17ab-57bd-8adf-88d63018f4bd': '1be5ba66-06b3-532b-a56b-3e850d8cd224',
      /* Section Summary */
      '1d6dd331-6952-5376-8972-38220ffdb61c': 'a3be3440-4b56-52f8-9557-adde00c2e05b',
      /* Section Quiz */
      'd39b2974-73b3-5e9b-8f2a-22877b408a81': 'adee0b77-2fef-56d8-a6de-1e7b1cdf7911',
      /* Short Answer */
      'b87ddd05-92b5-5aef-8d08-5503a02b0abd': '814ff517-344f-55ce-9c31-142aef75f99f',
      /* Further Research */
      '2f66caf6-a94f-528b-ab3f-04b716aa52d4': '91ebd87c-8bdc-5b45-ad22-6b05e73b8845',
      /* References */
      '196480ca-f09f-55fd-ad23-e6b46fd357a7': 'af919e39-2420-50b3-b7c4-927477936b53',
      /* 4.0 Introduction to Society and Social interaction */
      '31eae3d7-1b57-4c24-ad0b-d08a2851b70d': 'ef238876-14ce-464f-ac5a-e30d656d77b7',
      /* 4.1 Types of Societies */
      'aace8da1-b83e-4a5e-bfb8-5bd44699381a': '526f33fb-2ed8-4d15-b2e5-2b83a2b97849',
      /* 4.2 Theoretical Perspectives on Society */
      '6414e0c9-1e95-4b06-af38-b11762cb667e': 'c1bc1aa5-03ef-4909-90b3-f47d33bc0c85',
      /* 4.3 Social Constructions of Reality */
      'd06ad985-cecb-48b4-b222-197d04abc6a1': '040ac094-d7eb-4761-840f-04f22aa30797',
      /* Key Terms */
      'f3a073c2-5789-50f8-abfb-e5214c816bbd': 'c4c9abf9-c042-5f37-bf01-7db2b6caf4ad',
      /* Section Summary */
      'e0f14b6d-4df2-5d69-b17a-25889f6ad2f7': '48030256-e74d-5d2b-a065-d48033586935',
      /* Section Quiz */
      '038c8c7b-7161-5d23-8f14-cf3b8a808c65': '557ec685-2804-56df-83f5-73c4973a08c7',
      /* Short Answer */
      '357b7a1c-af6e-501c-87c9-c47f48d86f66': '50f0bc56-f861-54aa-88fc-75ed9a499ac7',
      /* Further Research */
      'aa893fc1-d064-5e30-9c7b-9296106faf21': 'dafd668a-d777-53b6-976f-0beaf08c417f',
      /* References */
      'a38bc07c-fa38-5796-9277-62f01d15925b': '544540fe-694e-5490-aaca-6e6ed6f9a5f9',
      /* 5.0 Introduction to Socialization */
      '52eff48e-e18d-4231-9fe3-eb7ffb9ee365': '432870f9-ca8c-475d-b171-11af7c328514',
      /* 5.1 Theories of Self Development */
      '08e4a1f1-738c-4296-b07d-e13fa2973681': 'c55c99ae-0516-4279-abd1-755d85f42bab',
      /* 5.2 Why Socialization Matters */
      'cde4e88d-3f69-4711-86d9-4f3b9697383b': 'bac65f73-c682-4565-9160-fda8409a9e0f',
      /* 5.3 Agents of Socialization */
      '3256e44f-a765-4c3a-8728-3a6c92b49a65': '4a762cc1-da3a-408d-8fcb-a5f57c6af751',
      /* 5.4 Socialization Across the Life Course */
      '269040ea-022f-40d1-b2f7-4b9219fa096d': '7a006b94-2b4a-4f60-ac2e-5f1cf8500a47',
      /* Key Terms */
      '07d1d306-3853-5c9d-b6d4-7ccfe3ee7a3d': '76bd8926-ac59-58e1-9dfb-83c2a91a416a',
      /* Section Summary */
      'd5d336d4-ebb9-5d70-a910-cdbbc7400cf7': '0942e215-ddb1-555a-a641-1a86824364a3',
      /* Section Quiz */
      '6b6d5e1c-0c63-52cf-a7bc-e79c2f94dfb1': '750f34cc-6dad-549d-b038-0c8016f6b70d',
      /* Short Answer */
      '32af6c6d-5b12-5218-a5e9-8bf8eb883b06': 'b3b9593c-b248-5306-b6a1-2964e9c45d81',
      /* Further Research */
      'dcbec3a2-5246-5ea7-b99a-076f0ae94045': 'f07c13af-ecd9-54b4-93ba-60826ed9de52',
      /* References */
      '24cb4487-b5c5-5afc-8296-fb7de89cc39c': '4b36eb17-5317-5bba-ac4f-2df38ff0b7c3',
      /* 6.0 Introduction Groups and Organizations */
      '74c17c8b-542d-4b6d-81b8-1188530fd1c3': '45a4685e-ef8f-4bfb-a584-4d023fa60bd9',
      /* 6.1 Types of Groups */
      'd95043f3-b879-4ad1-bd2c-7654f592c853': '2e236b4a-85d4-4640-a7df-f91ce95d7f3a',
      /* 6.2 Group Size and Structure */
      'a2b20cc9-c475-4b89-bf51-03ed75861dca': '5af5f060-563c-46d6-9239-2dcc5eb17f46',
      /* 6.3 Formal Organizations */
      'aebb5e2c-a825-4192-a8c0-91678b449ec2': 'db3d2810-0166-495e-8254-1df166163826',
      /* Key Terms */
      '895c4144-c266-5859-90fc-e72118450c58': '1d4ac680-27de-5559-a408-daae93210185',
      /* Section Summary */
      '559f7e2c-6dbb-57d2-b070-c2b2ff0329b5': 'cf5077a4-1656-5b30-982d-d6d213e0519b',
      /* Section Quiz */
      'ddad5b74-659b-5027-9e9a-61a10a3e7c12': '9ebea235-d15f-5d6c-8271-57d879a11aea',
      /* Short Answer */
      'bd671f7f-19b9-5632-9e88-54b670385e46': '8bd0894e-d064-55cc-8822-4ffdadf1d6fe',
      /* Further Research */
      '7621e1be-0583-558d-8222-f2a5924f50b5': '70a3dd0f-a08f-5c16-9346-41b8bfe4bd1f',
      /* References */
      '96a98d9e-8afe-5029-a453-e7265f835255': '174bd848-bde1-5453-a70a-805a22b76ec0',
      /* 7.0 Introduction to Deviance, Crime, and Social Control */
      '178fcbde-9ec6-46de-812f-1a44ad5144a5': 'e22a4d88-dd1f-410f-a15d-5d1a16caa3f4',
      /* 7.1 Deviance and Control */
      'cef21f33-7a41-49c6-b129-1a4e20b2b64d': '73acf5b5-9551-4ec3-8208-0938b2acc762',
      /* 7.2 Theoretical Perspectives on Deviance */
      '398ece58-90b3-4378-b774-f71e06bab8fe': '334bb070-bffe-4cea-8386-2ebc455e5e6c',
      /* 7.3 Crime and the Law */
      'dbfef635-98d1-49e6-ad56-efa7b91f506f': '5520305c-c934-4d73-8779-229edab703ab',
      /* Key Terms */
      '755fdfbf-5477-51bc-93ee-48b980aa0ff6': 'd2dfdcf6-d4eb-5b1a-80a8-c273e6741907',
      /* Section Summary */
      '1dc48300-8875-5395-b80b-f205a684a496': '0a0e762e-17fc-5441-9230-b04ddd776928',
      /* Section Quiz */
      'caaf7ecf-64ba-5f93-ba9a-ff517eff8d60': '9e41a89e-a125-538c-ae05-bc5ffd1f345a',
      /* Short Answer */
      '10c7e5fd-ac08-56be-ad6a-26c0f28f5e9e': 'fd892ab1-ce8d-574e-bb7e-e5905f6d3a19',
      /* Further Research */
      '595a4bb3-1f83-5077-b51e-b9f05283476d': '66f60179-0d91-5530-82c4-01729fbdeb72',
      /* References */
      '24cb04bf-fbcb-57c0-be0a-3c920af8a3e3': 'b4b62925-6613-500a-8a17-d53112276c07',
      /* 8.0 Introduction to Media and Technology */
      '022f74e4-8ebc-4232-b3f1-e052ee6ef711': '62b4811d-0c36-4175-b4b9-b87e0121aa67',
      /* 8.1 Technology Today */
      'ff98c048-3f87-453f-a5f9-fd962553166d': 'fcabfd7d-c9bf-4365-b3bc-37548cf60c27',
      /* 8.2 Media and Technology in Society */
      'fd4e4037-aa50-4849-8c69-0d7b80d3ef3c': '8c1fe4e0-906f-4831-a5f8-f637302b9998',
      /* 8.3 Global Implications of Media and Technology */
      'f8e4d21a-488f-491c-9e07-968a0b3e48ba': 'd3311627-9427-42b7-ba60-7fc46ebc0cb1',
      /* 8.4 Theoretical Perspectives on Media and Technology */
      '62b3caf7-b83a-4ff1-bb52-953afc1a9b6d': '9771fb31-def5-4866-9a53-aa4e4eefead0',
      /* Key Terms */
      '6551d9c2-0c2f-572e-8c68-8f2ec1b59de0': '8c49ae1b-2ea7-5916-80f7-42d63d0ad40a',
      /* Section Summary */
      'ab275695-ee4d-56b0-86d3-a32f84e00d10': 'db708cdf-4a08-542c-bd50-58c9772b16c5',
      /* Section Quiz */
      'fd1031b4-bdb6-5ad5-a685-987022ef64b5': '53e1474d-0f7f-5584-9e45-44bb500c4f90',
      /* Short Answer */
      '0c59a8d5-8fe1-531f-9d07-1fb717097b5d': '9669de69-d898-51ff-85e0-a1e4d8b3a2fe',
      /* Further Research */
      '83f59f29-67c8-53dd-bf85-6b63bad1c501': '455b76a8-d9ee-5bda-8966-f7c1ee406d69',
      /* References */
      '3a5335cb-a85c-5760-835e-3f10c211b46c': '21b121be-8f4e-5147-8d02-5aac5d3ef1f1',
      /* 9.0 Introduction to Social Stratification in the United States */
      '6e2fe486-093d-4e60-9ca3-1bbce5481b9c': '88050bef-46be-4c54-8104-43daf366c374',
      /* 9.1 What Is Social Stratification? */
      '2d80e77e-9e52-4bed-bf58-312c1b662922': '8915773e-2bab-4a4e-bf54-bb94d35b26e8',
      /* 9.2 Social Stratification and Mobility in the US */
      '61a9f276-1bde-4cef-ba2d-040bae4f90a2': '2bd53207-47cf-4968-8b04-dc1903f0225d',
      /* 9.3 Global Stratification and Inequality */
      '3f1c42b1-6494-47b1-9120-fa45b47f50b7': 'cb507d56-798b-4941-946a-fd825a0f5cd5',
      /* 9.4 Theoretical Perspectives on Social Stratification */
      '34faad00-f5b5-4d54-93ae-708adc6df1ca': '7b677f99-aa60-4f6e-9bbc-69d428d32beb',
      /* Key Terms */
      '17d10f13-acbf-5da2-8b7d-92aa6469bb6a': '54eea16e-ece1-553d-aa63-9d35ca2ffe32',
      /* Section Summary */
      '44d8e9ae-6dda-5645-a222-061e91359b4a': '9ed6dba5-9163-5d4f-b6e4-13940421ccd4',
      /* Section Quiz */
      '475665ab-3866-533d-8da6-2ef0473239e1': '2357ccfe-bf72-5000-ae6d-d46d984c23f7',
      /* Short Answer */
      '27f08dce-17be-5161-af7a-cf10eb895c1e': 'c6c7c34a-7766-5312-8667-daee94a50184',
      /* Further Research */
      'c53a68fd-ba3d-5995-b008-7241e365e793': '7574fdb6-dbaf-5d21-abbb-06fe9a4a4c5f',
      /* References */
      'c0c7d447-82d7-5335-905b-a33a87277496': 'ed116297-bcf3-5ab0-880b-3198fce81b5a',
      /* 10.0 Introduction to Global Inequality */
      'b6166e6a-8ffe-494c-a1f3-7e4acb668280': '5793e6d2-bc37-40a1-a6cc-de69a7687996',
      /* 10.1 Global Stratification and Classification */
      'ed308f6a-61dd-447b-b1b4-5118e7e25b22': 'f73ea9c9-c051-4d97-bea6-d235213f3a4e',
      /* 10.2 Global Wealth and Poverty */
      'd7c18fbb-e549-46da-aff4-68e60949d130': 'a88e70f0-2a90-4e98-a978-d895560224c5',
      /* 10.3 Theoretical Perspectives on Global Stratification */
      'c9770cc1-8415-475d-b691-99b289598974': '64172b6a-8685-486b-a784-f1c96fcde21e',
      /* Key Terms */
      '4c4d8bbb-1444-57cf-ad74-babe95fb414d': '88b91158-297f-5d37-bccb-498dbce7200e',
      /* Section Summary */
      '17aa110c-a483-53d5-a65c-1c7a56aa28a8': 'd320deef-9da2-52ed-a148-f7331d7417f9',
      /* Section Quiz */
      '927bd6e7-917c-5b94-b239-100d57909e99': '14c678c3-40ed-5053-a3a7-0f3a33f22b7a',
      /* Short Answer */
      '6ec0e754-cace-587e-8288-32587285a1be': '72290012-332c-5f42-829d-71ebd7925f07',
      /* Further Research */
      '8f759c99-2e79-59e4-b199-dce83572ee35': '071b3fbf-1b8e-5360-889e-c412e1b33939',
      /* References */
      'a05f3d1e-e473-5ead-9b3b-3b4bf7fee919': '2c7d690e-6046-5f85-a5a8-7d18155db28a',
      /* 11.0 Introduction to Race and Ethnicity */
      '1f4db786-0c13-415a-a456-ab07a24b2dfb': '7e6d02f2-9fe9-4696-927b-87b141005478',
      /* 11.1 Racial, Ethnic, and Minority Groups */
      'a55ca711-352c-47cb-ba17-35b00eb1f18a': 'ef3b2aab-ce5b-4b35-9ec7-7f588cf76737',
      /* 11.2 Stereotypes, Prejudice, and Discrimination */
      'd310a908-eb93-4b62-881a-12864fbb7157': '0edbeb4e-db80-4e63-afeb-e3b7448fe175',
      /* 11.3 Theories of Race and Ethnicity */
      'b1afff9f-c485-4245-8ca2-30de4666d03b': 'e207a1bd-229d-435d-b2be-feb218954337',
      /* 11.4 Intergroup Relationships */
      '134db5ed-6e53-42da-b821-6347b7b2554d': '05938a47-b4e3-4e5d-91f4-7d702ecbf185',
      /* 11.5 Race and Ethnicity in the United States */
      'b3cb90e7-b5d7-4e9c-91fc-e4fa2887f971': '6ae57670-6018-4994-a651-9a7755739413',
      /* Key Terms */
      'fe09c141-01dd-5590-9188-69ef5a5e17a5': '78d63ceb-648b-5313-ad98-abe8cea4447f',
      /* Section Summary */
      'c29e75a0-a50d-58eb-be4f-5488b0cc9c1f': '41a543cb-2a72-585d-96a1-d2631edec970',
      /* Section Quiz */
      '652bb24f-73ef-5e07-9f08-ede1abd98fde': '463739a7-4a70-54f3-bda4-5e256adf2435',
      /* Short Answer */
      '57468a5b-6a7c-5d2c-a5ef-1d28dbe3d603': 'b898a5c5-8c83-510e-88fe-79f9c87cf47b',
      /* Further Research */
      '9b0eaf7f-6cce-597d-8af9-419c6b08ad02': 'f0c1892a-143b-5b1e-9cf4-afef786223fa',
      /* References */
      'a26e7402-1fbb-5dd7-bb56-ce27a090f187': 'c5f5e38e-ea72-5c17-9609-04637a166ba5',
      /* 12.0 Introduction to Gender, Sex, and Sexuality */
      '4fff8b4d-65dd-4c21-9dc2-d33bfc9ae1c0': 'eca82f51-6e74-4d44-8897-784473cbaea3',
      /* 12.1 Sex and Gender */
      '26f66ec2-2527-441d-97a2-5e2d170cfc57': '2cb1bb9b-62a0-461d-af73-647db2608cef',
      /* 12.2 Gender */
      '2138442f-2ad7-4ec3-9972-fc913805b42a': '9c2a4870-25a6-4be7-958b-f4cfe2edc441',
      /* 12.3 Sex and Sexuality */
      '672dd126-9ce3-4175-9db3-5bff44be91fe': 'daa2005c-e793-403a-8138-8966743527b6',
      /* Key Terms */
      'd34f3e2f-e282-5faa-a4be-63a2b306dba0': '0f94920b-a036-555a-8a29-f14e9341a0c5',
      /* Section Summary */
      'd96d8526-4525-5b3e-946a-39b91009daf6': '0a403c38-a7a9-5be3-bc5f-de63b54effca',
      /* Section Quiz */
      'eae055b5-6e99-5ac3-a5c2-ad0d4872a68f': '8b53707b-b95a-50f2-9f51-4ca1687de0b7',
      /* Short Answer */
      '5d83af92-2759-528f-90c4-e7ccfd9b2df7': '7d4c4977-8e66-5380-a724-6d7191ed616e',
      /* Further Research */
      '2187aff8-22e6-5b9a-9853-0a4e6d1184c9': '265fb55c-6587-5978-ba8a-1351e8bd3e5a',
      /* References */
      'f7104d28-024c-5890-af2a-308f84aac6f9': '1cc1696d-66d9-5968-a35a-935eb4cbaafb',
      /* 13.0 Introduction to Aging and the Elderly */
      'acdddf86-67ea-453a-861f-efb0a4b50202': 'aa9e578c-a8de-4296-afa0-c205701738ef',
      /* 13.1 Who Are the Elderly? Aging in Society */
      'f4ce6106-f567-43a2-bcd9-f29ac6d7ea7c': '8907afb3-2050-406f-b99b-91656b44a872',
      /* 13.2 The Process of Aging */
      'd9df5e48-4b72-482e-b616-886926188054': '4a2cd675-c659-40bc-80a3-50ed002e844f',
      /* 13.3 Challenges Facing the Elderly */
      'a1ccdea8-6ff8-40ea-adc4-38bab44d04ee': 'd77aa9eb-7f03-41cb-ac74-b1058c46fcb8',
      /* 13.4 Theoretical Perspectives on Aging */
      'ade7fd74-8340-4c21-a537-7d4c8d67d965': '2bbe750f-a065-4ab9-a092-dad76f09fc23',
      /* Key Terms */
      '76e10f79-f412-59b1-bbb7-599cf2c5d6ea': '8d83c013-3164-5606-9e9a-212f0e93a385',
      /* Section Summary */
      '80faa867-d749-570f-993d-b5c7881f659d': '0101ddb1-2d87-5d33-9652-566484d5352c',
      /* Section Quiz */
      '8af16f1e-4a33-5dfa-8e7d-d43735eafdb7': 'bf731d38-db02-59c2-8fb4-8e999562356f',
      /* Short Answer */
      '4c3c8a4f-b5de-590b-b556-cfe6dbb53698': 'f35c8c5b-4fc7-5904-9e07-8d668ecce522',
      /* Further Research */
      '3968d24e-3260-52b3-bbed-ad6293cca527': 'b2cea58f-b0be-5cba-8fd9-048322e65a9e',
      /* References */
      '041738c8-d345-5e40-a352-0f08c9943a7b': 'e5ea53b5-0d32-5267-ac9e-2d4cc72aa820',
      /* 14.0 Introduction to Marriage and Family */
      'f05f32bf-ca44-4bcf-80c1-9377fb1d21f7': 'b69dea58-83eb-46fc-85db-b7a0fe7f60e6',
      /* 14.1 What Is Marriage? What Is a Family? */
      'fc2d2208-0a60-425e-9217-0d6ee659be7e': '8680e355-7ca9-4d25-81c3-2cf35d6a54a7',
      /* 14.2 Variations in Family Life */
      'fc504354-e135-4a28-b22a-2054dea6e315': '6b1bd506-8d81-4f46-bd02-4de90ad14be7',
      /* 14.3 Challenges Families Face */
      '5f441b6a-ae68-4d84-a106-1d1b011f0331': '5b7d753b-e94a-49ad-8ee8-a82a2ae23eb0',
      /* Key Terms */
      '5357eb1a-295e-535d-b7a7-4480557272e3': '36b70938-6842-5702-9842-4ced99b97847',
      /* Section Summary */
      '0576761e-98b8-547b-93b8-ef1aa119c3f0': 'b00ee4c1-572b-5304-99d1-ed44a9632175',
      /* Section Quiz */
      'c50a2095-d61d-53f4-bad7-8209f1322bf1': '8fbaf972-7fdf-54d5-b849-311c0b629144',
      /* Short Answer */
      'bfee28a0-f52a-565c-91c9-a0bb17130c7d': '8d24965a-4db1-52da-89e2-c39b991380ee',
      /* Further Research */
      '4d2104b1-81c7-5a2a-907f-590eaf48c4cf': 'bde54d1e-c574-5329-bfd7-92ab3535efd6',
      /* References */
      '829a290f-de59-5b7e-9d78-ca20353fb33b': '1c7a6a68-382e-5dd5-96ed-40edce734d25',
      /* 15.0 Introduction to Religion */
      'a7255255-e4f0-472c-81c0-54ab97cb2e68': '25a8930a-a75a-4104-af3e-3b3656168979',
      /* 15.1 The Sociological Approach to Religion */
      '53d3be59-277f-4139-b821-d04960c33d0b': 'f0212a7a-dcd7-4def-8e73-b75666b3d47a',
      /* 15.2 World Religions */
      '93ebe6b3-6e50-4dc1-9bc0-a55f6935bccb': '0d9cc835-5129-432b-99e8-6fe01c3492e6',
      /* 15.3 Religion in the United States */
      '5def2064-5c90-44ae-a963-6ecff5b80975': '195b3cdc-5a0a-476e-9fd0-c5592777b541',
      /* Key Terms */
      'fc0df951-64ba-5c34-9e8e-fea5d1f18a95': '78c82991-91f5-5f51-8bf3-e157f76e6ebb',
      /* Section Summary */
      '2fd07a19-bdf8-5896-9edd-a53ae70eeebc': 'f0f6e18a-f610-5298-8bac-41715b3452d0',
      /* Section Quiz */
      '5d03ae96-42d3-5f27-b5fc-5d410b33f042': '276f2f45-2e29-5408-96fd-7943a4b18147',
      /* Short Answer */
      '16c7c794-e94f-594a-90ab-90d181e6a74d': 'd8176288-2611-5915-8f6c-da42fe652ffc',
      /* Further Research */
      '8a45358a-8782-5283-bf97-0648fa051ab3': '2aed408d-4133-52e9-b353-c52575e3f14a',
      /* References */
      'a6d4f5bb-2647-596b-ae15-29fb3f95e55e': 'debc5f88-abe8-568f-a200-301503b91eaa',
      /* 16.0 Introduction to Education */
      '443cd6b3-64bc-4803-bd6a-eb216790a130': '0fa1e181-b3f5-4130-84c3-c56bed6087ba',
      /* 16.1 Education around the World */
      '55daa5bc-71b0-4578-8fec-51e39b581abd': '2dc215d3-3592-4ad3-8791-69203a46b56f',
      /* 16.2 Theoretical Perspectives on Education */
      '43b4a12e-66b6-479a-935d-f5e568a10463': 'b51cb16c-b4e3-4276-bc01-c1e55f3f7a80',
      /* 16.3 Issues in Education */
      '984be05e-c3eb-422d-9170-47b1f0d02c9c': 'c33eb672-e588-49db-8904-7bd3f59141f3',
      /* Key Terms */
      '274c4c62-bba8-538d-8430-544f3384e585': '0546b06a-c7bc-567f-b38e-a8cb233a3356',
      /* Section Summary */
      '63d49d09-a0ce-5dca-8241-6bbc6f43fb05': 'ab5ee79a-3784-5df6-bf8f-44ac8fc8bde3',
      /* Section Quiz */
      '50c15692-1e97-506f-8ee0-0531c41873f4': '0f722d8c-88dd-505f-bf7c-011ccaadf0d1',
      /* Short Answer */
      'dfd829bf-f7a4-5e98-8026-5c74636cb95c': '517eebad-f299-5029-94e9-e07a1b29c1ec',
      /* Further Research */
      '2cf3f92d-299a-51a3-b8f3-39ef0cf2b380': 'fb065441-5227-59f8-afff-7a872cade2d4',
      /* References */
      '9f082306-fe4b-59bf-b747-abf39b3783d3': '4d7eabfe-45a7-552e-88a8-339305d3d01a',
      /* 17.0 Introduction to Government and Politics */
      '75703577-ab2a-4b1d-860f-94514729c298': '70dc2bd6-2797-4873-9ff5-d99883edee8c',
      /* 17.1 Power and Authority */
      '1af78294-fbeb-49fe-b2cf-fd747f5a3e2e': '38f28809-b520-472f-8641-8f41b1aa7f39',
      /* 17.2 Forms of Government */
      'bf6698dd-c4d7-4559-82b2-3915859e3d75': '8b0aaf0a-92d9-4d3b-8de7-b0fd43e9b0cd',
      /* 17.3 Politics in the United States */
      '1c4bead3-4898-4fe9-b5f9-fb91e8a00c3a': '103fb4d3-3c1c-40c8-bb67-fba843c4b50a',
      /* 17.4 Theoretical Perspectives on Government and Power */
      '940de604-e01b-4565-81df-78985b79919a': '885f8ec6-75f0-4444-a0ec-6bf5d421dfb6',
      /* Key Terms */
      '5675bf85-db89-5491-930a-d74314e236d6': 'd76f5d62-12b7-502d-acc4-b829796346a3',
      /* Section Summary */
      '1ba33a0d-26cd-511e-a017-3bd91f13a2cd': 'c5b1fd91-a87f-54b2-b910-fbaca0b734c3',
      /* Section Quiz */
      '2e8e15a5-3349-5135-b51f-8f7e594d0590': 'ba0fc0e8-abdf-517e-89fd-94598c70505f',
      /* Short Answer */
      'ce3f1ab2-861a-5032-9aca-efed828c69c1': '924e61c5-9158-5bad-a1b1-963d18658c4d',
      /* Further Research */
      '85809e34-cda8-556a-be26-0bf61a352927': '4c383005-6f97-574c-b1d6-8086563c8b00',
      /* References */
      'd2cda32c-5912-5ae2-9ae1-e33464393095': '85e6110c-f8e2-5b92-871f-86d0d2928bd7',
      /* 18.0 Introduction to Work and the Economy */
      '6bde5892-e610-4f5f-bfbb-84f624ace8c6': '2dce905a-8b18-4744-9059-68bf253fcdb1',
      /* 18.1 Economic Systems */
      '36f9cf93-9c5d-41f1-8c14-d7c89fea9b85': '9736b5e6-5c55-4427-bbea-583631ec35d5',
      /* 18.2 Globalization and the Economy */
      '5fe19034-9a53-44c7-bdc5-346d0d0753dc': 'bd95b55e-bd6e-42d5-9b24-d7245a4b2f0c',
      /* 18.3 Work in the United States */
      '71d09a20-73f5-4265-9bae-7c5bc70a0a47': '50990608-0ac5-48eb-aa99-a9895f3c684e',
      /* Key Terms */
      'cd538d9e-7dd9-5766-97ac-0d77e5dd6b06': '4d93247a-1c3d-5510-995a-b6946a5b3f5f',
      /* Section Summary */
      '76636eed-80a1-5ad6-acc4-0282db887f1a': 'c60f2972-8c8a-5705-b76a-4d0c132a2d9b',
      /* Section Quiz */
      '8e7c57da-459b-523b-9257-6341e874c217': '833b6dba-b21a-5668-9338-f45de18682c1',
      /* Short Answer */
      'f14b1e01-a3b0-59ce-81ee-9e623af69d21': '9c8b9e83-a633-5963-8901-b0087280e3a0',
      /* Further Research */
      'f6f63364-a74d-5d57-96e5-66e6f7ebdaae': '12ba2d73-2bad-5655-8b5b-c2462dab65e7',
      /* References */
      '5ea90537-033f-51e7-8f4a-d81a97039d8c': '983b0c75-9fde-59d2-b6ea-e27e1fb956a8',
      /* 19.0 Introduction to Health and Medicine */
      '5f90d10f-2f6a-486c-86d4-893653b26b83': '924e725d-f89a-4489-b5b0-b54fbbba9bc0',
      /* 19.1 The Social Construction of Health */
      'e31c5006-5e21-43fc-b070-c5347066cd96': 'be196e13-bfd0-4c6f-ba08-dc3e0f243330',
      /* 19.2 Global Health */
      'd1ef539d-3612-4154-b787-6835fe93703b': '6bd7a019-4c5f-4d67-bd2b-e95487d77b72',
      /* 19.3 Health in the United States */
      'f3a2b187-e44d-4a5f-af59-ee4bcd39046f': '0e24f38e-51de-48b7-98c7-e2cb84012915',
      /* 19.4 Comparative Health and Medicine */
      '86d65916-f669-4a65-9187-15d83e2d1689': '82e9a288-e88b-44e5-b72d-65c467ac1700',
      /* 19.5 Theoretical Perspectives on Health and Medicine */
      '54923470-ad35-40ef-b09c-da89b0e19da5': '6e9cde25-53c7-4960-b31b-3ecccbe1e701',
      /* Key Terms */
      'd88185c1-db86-5389-975a-77f5d1e2c4d9': 'f69245d7-b209-51fe-9163-815b37716735',
      /* Section Summary */
      'e5d863ee-74f9-5975-90f8-4636b87dbf1b': '47741bae-263f-53fb-8219-c2e833ab7572',
      /* Section Quiz */
      '981cfc29-bbb3-5e96-96e6-ca5c7174e678': '24168225-d631-5abf-83f5-13e6a12de9c1',
      /* Short Answer */
      '03b7607c-ee84-5ff1-bca2-de3b05df710c': 'a4767618-75cd-567d-8ef7-0c991654c683',
      /* Further Research */
      'ec196185-0f4b-538d-8dea-ab888976e35e': 'c19e515e-e626-5a59-82e8-c77c540b6dde',
      /* References */
      '52707f50-92d9-54c7-a635-63b37829f17c': '012ea5c1-5360-5851-995e-56a951d038ea',
      /* 20.0 Introduction to Population, Urbanization, and the Environment */
      '8803c7d4-c848-4b4e-a743-82f7477eb764': '2578a895-c99f-4149-aab4-a8aa6c03f4b5',
      /* 20.1 Demography and Population */
      '2cf134f9-f88e-4590-8c33-404ead13ab83': 'aaec018d-a1e6-4e6d-9d85-36f8274a9085',
      /* 20.2 Urbanization */
      '4c117289-4d19-4892-82dd-c0e820ea9041': '8ca3d600-1a6f-4535-94e4-1c13cb77d4c9',
      /* 20.3 The Environment and Society */
      'a9c17e87-c269-4cd2-b540-aaf6cc273dbf': '7aed3dd9-7c4d-4a25-b903-3529583215e6',
      /* Key Terms */
      '62697181-64c2-54a4-a557-9b7bd96f461c': 'e0647f6e-312c-5931-994a-0bc598e288eb',
      /* Section Summary */
      '7788b646-eccc-5e37-82ea-936eb32d87e4': '9172a477-7729-5e26-b7a6-4351baf53ba8',
      /* Section Quiz */
      '0123e588-6856-558c-bf33-e6697299568c': 'd1a089b7-81b7-5afd-8ec3-b833c3bf1fa7',
      /* Short Answer */
      '253e7ab7-491c-5ce1-ab8a-ea36a97a74c2': '7394d55d-1c3e-532d-a40a-50e2777f0c03',
      /* Further Research */
      'b5efbc22-ba7f-5de3-a167-acca92e01ac1': '7cb7a300-7c05-53fd-b058-fa9a8c0e0153',
      /* References */
      '73d65c29-d568-58bd-89e0-03117acdb9b2': '6b8d1eb6-cc43-5242-8756-1a641de53290',
      /* 21.0 Introduction to Social Movements and Social Change */
      '31d1b1ea-ca56-4379-af73-b08eef4165ab': 'e475e719-67e9-4a51-9c2b-313d009991eb',
      /* 21.1 Collective Behavior */
      '21126f9c-6b12-4860-a396-01a3ba24393e': '6e69fbe2-9c5d-4c03-85db-565c56621331',
      /* 21.2 Social Movements */
      'cea139cd-98de-4841-91e6-abcb0baa92da': '1272acf1-44da-4f2c-88e7-4eff807738e6',
      /* 21.3 Social Change */
      'be2e1e07-67a1-469b-b17c-109fda35d510': '4937c948-e669-42a4-98cc-fe18f2370de1',
      /* Key Terms */
      '816c3585-f399-5dd4-b14c-fd6d2b32b7e0': '09cc85ce-9847-537b-ab08-37e80939a251',
      /* Section Summary */
      '2e22c33f-e4fd-592f-bca4-c6396e64c42c': 'b558a795-7e6c-5874-a0da-9f2541a463c2',
      /* Section Quiz */
      '977ba877-734c-599f-84cf-83d345f0ed27': '0f00b8dd-3812-5212-8c38-4ac27a0c6c97',
      /* Short Answer */
      'fa660f0f-bd7c-596e-a16a-af7a847bbd34': 'db6b2586-0c56-5cc3-80b1-005113b5e393',
      /* References */
      'db5b4f91-0614-5937-a7af-a63c79980444': '904585e1-6170-5852-8e07-ca492b8d3b56',
    }],
  ],
} as CanonicalBookMap;
